import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useSelector } from "react-redux";
import { v4 as uuid } from "uuid";
import { useNavigate, useParams } from "react-router-dom";
import axiosinstances from "../../Helper/useAxios";
import Pagination from "../../utils/Pagination";
import Button from "react-bootstrap/Button";
import { isSuperAdmin, isUserAdmin } from "../../utils/comman/Common";

const CREATE_NEW='CREATE_NEW';
const ASSIGNED_ENTITY_LIST='ASSIGNED_ENTITY_LIST';
const PRODUCT_LIST='PRODUCT_LIST';

export default function ProductGroup() {
  const unique_id = uuid();
  const [axiosInstance] = axiosinstances();
  const [table, setTable] = useState([]);
  const [assignTablelist, setAssignTablelist] = useState([]);
  const token = JSON.parse(sessionStorage.getItem("token"));
  const requesterId = useSelector((state) => state.selectedretailerReqesterReducer.requesterId);
  const id = useSelector((state) => state.getprofilereducer?.getprofile?.id);
  const [productGroupId, setProductGroupId] = useState("");
  const [entityType, setEntityType] = useState("");
  const [entityId, setEntityId] = useState('')
  const [paginationDetails, setPaginationDetails] = useState({
	currentPage: 1,
	posts: [],
	loading: null,
	postsPerPage: 15
});
const [searched, setsearched] = useState('')
const [showList, setShowList] = useState(CREATE_NEW)
const [assignid, setAssignId] = useState('')
const [mappedPriceList, setMappedPriceList] = useState({})
const [selectedId, setSelectedId] = useState('')
  const date = new Date();
  //console.log("assignTablelist", assignTablelist);
  //console.log("productGroupId", productGroupId);
  //console.log("table", table);
  //console.log("entityType", entityType);
  const navigate = useNavigate();
  const tocreatePage = () => {
    navigate("/create-new-product-group");
  };
  const fetchproductGroupList = async () => {
    const response = await axiosInstance
      .get(`/api/v1/pricing/group/all`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "client-id": id,
          role: "ROLE_RETAILER_FINXPAY",
        },
      })
      .then((res) => {
        //console.log("table res", res);
        if (res.status === 200) {
          setTable(res?.data?.all);
        }
      })
      .catch((err) => {
        //console.log(err);
      });
    if (response) {
      const result = response.data.orders;
      if (result) {
      }

      return response.data;
    }
    return false;
  };
  const fetchproductGroupAssigmentList = async () => {
    const response = await axiosInstance
      .get(`/api/v1/pricing/group/assignment`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "client-id": id,
          role: "ROLE_RETAILER_FINXPAY",
        },
      })
      .then((res) => {
        //console.log("res assgn", res);
        if (res.status === 200) {
          setAssignTablelist(res?.data);
        }
      })
      .catch((err) => {
        //console.log(err);
      });
    if (response) {
      const result = response.data.orders;
      if (result) {
      }

      return response.data;
    }
    return false;
  };
  const getfilterData = () => {
    if (entityType !== "") {
      const ftrEntity = table.filter((data) => data.entityType === entityType);
      return ftrEntity;
    } else {
      return table;
    }
  };
  const entitleFilterData = React.useMemo(
    () => getfilterData(),
    [entityType, table]
  );
  // useEffect(()=>{
  // getfilterData()
  // },[entityType])
  
  const indexOfLastPost = paginationDetails.currentPage * paginationDetails.postsPerPage;

	const indexOfFirstPost = indexOfLastPost - paginationDetails.postsPerPage;
  const currentPosts = entitleFilterData !== undefined && entitleFilterData !== '' && Array.isArray(entitleFilterData)  &&  entitleFilterData.filter((val) => {
		if (searched === '') {
			return val
		} else if(searched !== '' && !val?.id.toLowerCase().includes(searched.toLowerCase())){
      let assignFilterList = assignTablelist.filter(assign=>assign.id.toLowerCase() == searched.toLowerCase())
      if( assignFilterList[0]?.groupId !== undefined && val.id == assignFilterList[0].groupId){
       return val
      }
     } else if (val.id !== undefined && val?.id.toLowerCase().includes(searched.toLowerCase())) {
			return val
		} 
	}).slice(indexOfFirstPost, indexOfLastPost);
  useEffect(() => {
    if (id !== undefined) {
      fetchproductGroupList();
      fetchproductGroupAssigmentList();
    }
  }, [id]);
  const getAssignListData = () =>{
    if(Array.isArray(assignTablelist) && assignTablelist.length > 0){
      const assignRetailers = assignTablelist.filter(val => val.groupId === assignid )
      return assignRetailers 
    } else{
      return []
    }
   
  }
  const selectedAssignList = React.useMemo(
    () => assignid !== '' && getAssignListData(),
    [assignid, showList]
  );
  //mappedPriceList
  const getPriceListData = () =>{
    if(Object.keys(mappedPriceList).length > 0 ){
      let list = []
      for (const [key, value] of Object.entries(mappedPriceList)) {
        //console.log(`${key}: ${value}`);
        list.push(value)
      } 
      return list
    }
   
  }
  const selectedPriceList = React.useMemo(
    () =>  getPriceListData(),
    [showList, mappedPriceList]
  );
  //console.log('selectedPriceList', selectedPriceList)
  const handleClicked = (e, values) => {
    setProductGroupId(e.target.value);
    setEntityType(values.entityType)
  };
  const createProductPrice = async () => {
    let productDetails = {
      header: {
        msgType: "ASSIGN_PRICING_GROUP",
        service: "PRICING",
        channel: "ADMIN",
        requesterId: requesterId,
        requestId: unique_id,
        time: date,
      },

      entityType: entityType,
      entityId: entityId,
      pricingGroupId: productGroupId,
      actionBy: id,
      reason: "Adding for oxigen partner",
    };
    const url = `/api/v1/pricing/group/assign`;
    const response = await axiosInstance
      .post(
        url,
        {
          ...productDetails,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "client-id": id,
            role: "ROLE_RETAILER_FINXPAY",
          },
        }
      )
      .then((res) => {
        //console.log("user created res-->", res);
        if (res.status == 200) {
          setEntityId('')
          setEntityType('')
        }
      })
      .catch((err) => {
        //console.log(err);
      });
    return false;
  };
  const getProductList = (list) =>{
	const plist = Object.keys(list)
	return Array.isArray(plist) && plist.length || 0
  }
  const getAssignedRetailer = (id) =>{
    if( Array.isArray(assignTablelist) && assignTablelist.length > 0){
      const assignRetailers = assignTablelist.filter(val => val.groupId === id)
      return assignRetailers.length || 0
    } else {
      return 0
    }
    
  }
  const showSelectedAssign = (id) =>{
    setShowList(ASSIGNED_ENTITY_LIST)
    setAssignId(id)
    setSelectedId(id)
  }
  const showSelectedPrice = (priceList, id) =>{
    setShowList(PRODUCT_LIST)
    setMappedPriceList(priceList)
    setSelectedId(id)
  }
  const assignCheck = () =>{
    let disable = true
    if(entityType !== '' && productGroupId !== '' && entityId !== ''){
      disable = false
    }
    return disable
  }
  return (
    isSuperAdmin(id) && isUserAdmin(id) &&
    <div class="midcontant">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 col-md-6 col-lg-7">
            <div class="head-pr">
              <div class="row mt-4">
                <div class="col-12 col-md-6 col-lg-3 col-xl-4 mb-1 mt-1">
                  <h3>Products Group</h3>
                </div>
                <div class="col-12 col-md-6 col-lg-5 col-xl-4 mb-1 mt-1">
                  <div class="search-pr">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Search group..."
                      onChange={(e)=>setsearched(e.target.value)}
                      value={searched}
                    />
                  </div>
                </div>
                <div class="col-8 col-md-6 col-lg-2 col-xl-1 mb-1 mt-1">
                  <div class="action">

                    <button
                      type="button"
                      class="add btn"
                      data-toggle="tooltip"
                      title="Add New Group"
                      onClick={tocreatePage}
                    ></button>
   
                  </div>
                </div>
                {
                 entityType !== undefined &&  entityType !== '' && <div class="col-8 col-md-6 col-lg-2 col-xl-3 float-end  mb-1 mt-1">
                  <div class="action">
                    <button type="button" class="lbbtnremove"  onClick={()=>setEntityType('')} >Clear EntityType</button>
                  </div>
                </div>
                }
                
              </div>
            </div>
            
            <div class="productlist">
              <div class="table-responsive">
                <table class="table" style={{ borderCollapse:"collapse" }}>
                  <tbody>
                    <tr >
                      <th>
					          	   Select Id
                      </th>
                      <th>Group Name</th>
                      <th>Added Products</th>
                      <th>Assigned Entity</th>
                      <th>Created Date</th>
                    </tr>
                    {Array.isArray(currentPosts) &&
                      currentPosts.length > 0 &&
                      currentPosts.map((val, index) => {
                        return (
                          <tr key={index} className= {selectedId == val.id ? 'tableactive' : ''} >
                            <td>
                            
                              <div class="form-checkbox">
                                <div class="form-check form-check-inline">
                                  <input
                                    class="form-check-input"
                                    type="radio"
                                    name="productgrouplist"
                                    id="pglist"
                                    value={val.id}
									                 checked={productGroupId === val?.id}
                                    onClick={(e) => handleClicked(e, val)}
                                  />
                             
                                </div>
                              </div>
                            </td>
                            <td>{val?.id}<p style={{fontSize:'10px' , margin:'0px', padding:'0px'}} >Entity Type- {val.entityType}</p></td>
                            <td>
                              <button class='a-button' onClick={()=>showSelectedPrice(val?.pricingMap, val?.id)} >
                              <a style={{cursor:'pointer'}} class="addpro">
                                {getProductList(val?.pricingMap)}
                              </a> </button>
                            </td>
                            <td>
                            <button class='a-button' onClick={()=>showSelectedAssign(val?.id)}  >
                              <a  style={{cursor:'pointer'}} class="addro">
                             {getAssignedRetailer(val?.id)}
                              </a> </button>
                            </td>
                            <td>
                              {val.createdOn.replace("T", " ").slice(0, -4)}
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>

              <div class="row">
                {
                  Array.isArray(entitleFilterData) && entitleFilterData.length > 0 &&
                <div class="col-12 col-md-6">
                  <div class="totalno">Showing 1 to {Array.isArray(entitleFilterData) && entitleFilterData.length} </div>
                  </div> }
				{
                 Array.isArray(entitleFilterData) && entitleFilterData.length > 15  && searched == "" &&
					   <div class="col-12 col-md-6">
                     <Pagination
                     className="pagination-bar"
                     currentPage={paginationDetails.currentPage}
                     totalCount={  Array.isArray(entitleFilterData) && entitleFilterData.length}
                     pageSize={paginationDetails.postsPerPage}
                     onPageChange={page => setPaginationDetails((prev)=> {return({...prev, currentPage:page})})}
                     />
					 </div>
                    }
                
              </div>
            </div>
          </div>
          {
            showList === CREATE_NEW ?
            <div class="col-12 col-md-6 col-lg-5 mt-4">
            <div class="card">
              <div class="addnewproduct">
                <div class="cardheader">
                  <h3>Asign Product Group to Retailers</h3>
                </div>
                <div class="row">
                  <div class="col-12 mb-2">
                    <div class="form-floating">
                      <select
                        class="form-select"
                        id="entityType"
                        onChange={(e) => setEntityType(e.target.value)}
                        name="entityType"
                        value={entityType}
                      >
                        <option value="">Select</option>
                        <option value="CUSTOMER">CUSTOMER</option>
                        <option value="SUPPLIER">SUPPLIER</option>
                        <option value="RETAILER">RETAILER</option>

                        <option value="DISTRIBUTOR">DISTRIBUTOR</option>
                        <option value="PARTNER">PARTNER</option>
                        <option value="CORPORATE">CORPORATE</option>

                        <option value="WHITELABEL">WHITELABEL</option>
                        <option value="HO">HO</option>
                      </select>
                      <label for="entityType">Entity Type</label>
                    </div>
                  </div>
                  {productGroupId !== "" && (
                    <div class="col-12 mb-2">
                      <div class="form-floating">
                        <input
                          type="text"
                          class="form-control"
                          id="pgids"
                          placeholder="Enter Product group Id"
                          disabled
                          value={productGroupId}
                        />
                        <label for="pgids">Product group Id</label>
                      </div>
                    </div>
                  )}
                  <div class="col-12 mb-2">
                    <div class="form-floating">
                      <input
                        type="text"
                        class="form-control"
                        id="RetailerID"
                        placeholder="Enter Entity ID"
					            	value={entityId}
						            onChange={(e)=>setEntityId(e.target.value)}
                      />
                      <label for="RetailerID">Entity ID</label>
                    </div>
                  </div>
                  

                  {/* <div class="col-12 mb-2">
                    <div class="form-floating">
                      <input
                        type="text"
                        class="form-control"
                        id="Categorylabel"
                        placeholder="Enter Category label"
                      />
                      <label for="Categorylabel">Category label</label>
                    </div>
                  </div> */}

                  <div class="col-12">
                    <button type="button" class="btn btn-primary" disabled={assignCheck()} onClick={createProductPrice}>
                      Asign Now
                    </button>
                    
                  </div>
                </div>
              </div>
            </div>
          </div> : showList === ASSIGNED_ENTITY_LIST ? 
          <div class="col-12 col-md-6 col-lg-5 mt-4">
            <div class="card">
            
              <div class="addnewproduct">
                
                <div class="row">
                  <div class="col-12">
                  <Button variant="danger" data-toggle="tooltip" title="Close"  onClick={()=>setShowList(CREATE_NEW)} style={{float:'right'}} size="sm">
                        close
                    </Button>
                    <label style={{marginTop:'0px'}} class="rolbl">Assigned Entity</label>
                    <div class="selectedro">
                      {
                     selectedAssignList !== undefined &&  Array.isArray(selectedAssignList) &&  selectedAssignList.length > 0 && selectedAssignList.map((val, index)=>{
                        return <div  class="rolist" data-toggle="tooltip" twipsy-content-set="true"  title={`Type-${val.type},ID-${val.id}, GroupId-${val.groupId}`}  >
                        {val?.groupId} 
                       
                      </div>
                       })
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>: showList === PRODUCT_LIST ? <div class="col-12 col-md-6 col-lg-5 mt-4">
            <div class="card">
              <div class="addnewproduct">
                
                <div class="row">
                  <div class="col-12">
                  <Button variant="danger" onClick={()=>setShowList(CREATE_NEW)} style={{float:'right'}} size="sm">
                    close
                    </Button>
                    <label style={{marginTop:'0px'}} class="rolbl">Product List</label>
                    <div class="selectedro">
                      {
                      selectedPriceList !== undefined && Array.isArray(selectedPriceList) &&  selectedPriceList.length > 0 && selectedPriceList.map((val, index)=>{
                        return <div  class="rolist">
                        {val} 
                      </div>
                       })
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>: ''
          }
          
        </div>
      </div>
    </div>
  );
}
